import { Nullable } from "../../pojo/Util";
import { Proto } from "../../pojo/Proto";
import { S25Xml } from "./s25.xml";
import { S25ObjectUtil } from "./s25.object.util";
import { isUndefined } from "./index";
import Result = Proto.Result;

export namespace S25Json {
    export function toJson(obj: any): string {
        return JSON.stringify(obj);
    }
    export function jpath(jsonIn: any, path: string): any[] {
        //search json with xpath
        const ret: any[] = [];

        let json: any = S25ObjectUtil.deepCopy(jsonIn);
        json = JSON.parse(JSON.stringify(json).replace(/\$/g, "_"));

        const xmlString: string = "<root>" + S25Xml.json2xml_str(json) + "</root>";
        let xmlDoc: any; // = $.parseXML(xmlString);

        if (window.DOMParser) {
            const parser: any = new DOMParser();
            xmlDoc = parser.parseFromString(xmlString, "text/xml");
        } else {
            //IE...
            xmlDoc = new ActiveXObject("Microsoft.XMLDOM");
            xmlDoc.async = false;
            xmlDoc.loadXML(xmlString);
        }

        let iterator: any;

        if (document.evaluate) {
            iterator = document.evaluate(path, xmlDoc, null, XPathResult.UNORDERED_NODE_ITERATOR_TYPE, null);
        } else {
            //IE is terrible...
            iterator = {};
            iterator._results = xmlDoc.selectNodes(path);
            iterator._currentIndex = -1;
            iterator.iterateNext = function () {
                iterator._currentIndex++;
                return iterator._results[iterator._currentIndex];
            };
        }

        let result = iterator.iterateNext();
        while (result) {
            const val =
                S25Xml.xml_str2json(result.innerHTML) ||
                result.innerHTML ||
                result.xml ||
                new XMLSerializer().serializeToString(result);
            if (!isUndefined(val) && (val.constructor == Object || val.length > 0)) {
                ret.push(val);
            }
            result = iterator.iterateNext();
        }

        return ret;
    }
    /**
     * Parses a JSON string. If parsing succeeded the data is populated, if there was an error the error is populated
     * @param json String to parse
     * @return An array [data, error]
     */
    export function parseJson<T>(json: string | undefined): Proto.Result<Nullable<T>, any> {
        if (!json) return [undefined, undefined];
        try {
            return [JSON.parse(json), null];
        } catch (caughtError: any) {
            return [undefined, caughtError];
        }
    }
}
